<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="master_svg0_2315_15911">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
      <clipPath id="master_svg1_2315_15919">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
    </defs>
    <g clip-path="url(#master_svg0_2315_15911)">
      <g clip-path="url(#master_svg1_2315_15919)">
        <g>
          <g>
            <path
              d="M2.199999591270447,6.749996622085571L7.100003591270447,10.369996622085571C7.587613591270447,10.629556622085572,8.172393591270446,10.629556622085572,8.660003591270446,10.369996622085571L13.549983591270447,6.749996622085571C13.788183591270446,6.702126622085571,13.959483591270446,6.492926622085571,13.959483591270446,6.249996622085572C13.959483591270446,6.007076622085571,13.788183591270446,5.7978666220855715,13.549983591270447,5.749996622085572L8.660003591270446,2.719999622085571C8.175223591270447,2.4493289220855714,7.584773591270447,2.4493289220855714,7.100003591270447,2.719999622085571L2.199999591270447,5.789996622085571C2.0062235912704467,5.8707366220855715,1.8799998912704468,6.060076622085571,1.8799998912704468,6.269996622085571C1.8799998912704468,6.479926622085571,2.0062235912704467,6.669256622085571,2.199999591270447,6.749996622085571ZM7.880003591270447,3.539996622085571L12.349983591270448,6.269996622085571Q12.399983591270447,6.269996622085571,12.349983591270448,6.269996622085571L8.420003591270447,9.359996622085571C8.082393591270446,9.539556622085572,7.677613591270447,9.539556622085572,7.340003591270447,9.359996622085571L3.4100035912704465,6.269996622085571L7.880003591270447,3.539996622085571ZM13.549983591270447,8.539996622085571L13.439983591270448,8.539996622085571L8.660003591270446,11.999996622085572C8.175223591270447,12.270666622085571,7.584773591270447,12.270666622085571,7.100003591270447,11.999996622085572L2.3099995912704467,8.459996622085571L2.199999591270447,8.459996622085571C1.9877845912704468,8.534606622085573,1.8457835912704468,8.735056622085573,1.8457835912704468,8.959996622085571C1.8457834720614468,9.184946622085572,1.9877845912704468,9.385396622085572,2.199999591270447,9.459996622085571L7.100003591270447,13.069996622085572C7.584773591270447,13.340696622085572,8.175223591270447,13.340696622085572,8.660003591270446,13.069996622085572L13.549983591270447,9.459996622085571C13.737583591270447,9.37644662208557,13.858383591270448,9.190336622085571,13.858383591270448,8.984996622085571C13.858383591270448,8.779666622085571,13.737583591270447,8.593556622085572,13.549983591270447,8.509996622085572L13.549983591270447,8.539996622085571Z"
              fill="currentColor"
            />
          </g>
          <g>
            <path
              d="M14,16L2,16C0.89543,16,0,15.1046,0,14L0,2C0,0.89543,0.89543,0,2,0L14,0C15.1046,0,16,0.89543,16,2L16,14C16,15.1046,15.1046,16,14,16ZM2,1C1.44772,1,1,1.44772,1,2L1,14C1,14.5523,1.44772,15,2,15L14,15C14.5523,15,15,14.5523,15,14L15,2C15,1.44772,14.5523,1,14,1L2,1Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutDatax1',
} as DefineComponent
</script>
